/**
 * @license The MIT License (MIT)
 * @copyright Stanislav Kalashnik <darkpark.main@gmail.com>
 */

/* eslint no-path-concat: 0 */

'use strict';

var Emitter = require('cjs-emitter'),
    Gettext = require('cjs-gettext'),
    loader  = new Emitter();


if ( DEVELOP ) {
    loader._ = loader.gettext = loader.pgettext = loader.ngettext = function () {
        throw new Error(__filename + ': you cannot use this function before mag-gettext not yet loaded');
    };
}

/**
 * Wrap the given data with gettext instance
 * and export methods to the global scope.
 *
 * @param {Object} [data] localization data
 */
function prepare ( data ) {
    var gettext = new Gettext(data);

    loader._ = loader.gettext = gettext.gettext;
    loader.pgettext = gettext.pgettext;
    loader.ngettext = gettext.ngettext;
}


/**
 * Main application language
 */
loader.defaultLanguage = 'en';


/**
 * Simple gettext implementation.
 *
 * @param {Object} config options
 * @param {string} [config.path=lang] relative path to project root
 * @param {string} config.name language name
 * @param {string} [config.ext=json] language file extension
 * @param {function} callback hook on ready
 */
loader.load = function ( config, callback ) {
    var xhr;

    if ( DEVELOP ) {
        if ( !config.name || typeof config.name !== 'string' ) {
            throw new Error(__filename + ': config.name must be a nonempty string');
        }
        if ( callback && typeof callback !== 'function' ) {
            throw new Error(__filename + ': wrong callback type');
        }
    }

    // defaults

    callback = callback || null;
    config.ext  = config.ext  || 'json';
    config.path = config.path || 'lang';

    // is it necessary to request a localization file?
    if ( config.name === loader.defaultLanguage ) {
        // no
        prepare();
        if ( callback !== null ) {
            callback(null);
        }
    } else {
        xhr = new XMLHttpRequest();

        xhr.onload = function () {
            var jsonParseError, json;

            try {
                json = JSON.parse(xhr.responseText);
            } catch ( error ) {
                jsonParseError = error;
            }

            if ( jsonParseError ) {
                xhr.onerror(jsonParseError);
            } else {
                prepare(json);
                if ( callback !== null ) {
                    callback(null);
                }

                // there are some listeners
                if ( loader.events['load'] ) {
                    // notify listeners
                    loader.emit('load');
                }
            }
        };

        xhr.ontimeout = xhr.onerror = function ( error ) {
            prepare();

            if ( callback !== null ) {
                callback(null);
            }

            // there are some listeners
            if ( loader.events['error'] ) {
                // notify listeners
                loader.emit('error', error);
            }
        };

        xhr.open('GET', config.path + '/' + config.name + '.' + config.ext, true);
        xhr.send(null);
    }
};


// public
module.exports = loader;
